import { Component, ViewEncapsulation, input } from '@angular/core';

/**
 * Encabezado de dashboard: el título a la izquierda y, a la derecha, los
 * controles en una fila. Se desplaza con el contenido. Zonas:
 * período (`[filtros-periodo]`), filtros propios del dashboard
 * (`[filtros-campos]`) y acciones (`[filtros-acciones]`: restaurar orden,
 * exportar, actualizar).
 *
 * Los botones de opciones y los campos toman forma de píldora y la misma
 * altura (36 px), como el buscador de los listados.
 *
 * Un filtro que afecta a un solo panel no va acá sino en el encabezado de
 * ese panel (`[panel-acciones]` de `app-dashboard-panel`).
 */
@Component({
  selector: 'app-dashboard-filtros',
  templateUrl: './dashboard-filtros.component.html',
  styleUrls: ['./dashboard-filtros.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class DashboardFiltrosComponent {
  /** Nombre del dashboard */
  public titulo = input<string>('');
}
